import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {addSuccessNotify} from "@Redux/slices/notifications/NotificationSlice";
import {asyncLogout} from '@Redux/slices/user/UserSlice'

import {AlertType} from "@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert/types";

export const setPriceAlerts = createAsyncThunk<
  { alerts: AlertType[] },
  { alerts: AlertType[] },
  { state: { priceAlerts: PriceAlertsState } }
>('priceAlerts/setPriceAlerts', async (payload, { dispatch, getState }) => {
  const { alertsList: prevAlerts } = getState().priceAlerts

  const newlyCompleted = payload.alerts.filter((newAlert) => {
    const prevAlert = prevAlerts.find(a => a.uuid === newAlert.uuid)
    return prevAlert && prevAlert.completed_at === null && newAlert.completed_at !== null
  })

  if (newlyCompleted.length > 0) {
    dispatch(
      addSuccessNotify({
        message: `${newlyCompleted.length} alert${newlyCompleted.length > 1 ? 's' : ''} triggered`,
      })
    )
  }

  return payload
})

interface PriceAlertsState {
  isLoading: boolean
  error: null | string
  alertsList: AlertType[]
}

const initialState: PriceAlertsState = {
  alertsList: [],
  isLoading: false,
  error: null,
}

export const PriceAlertsSlice = createSlice({
  name: 'priceAlerts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setPriceAlerts.pending, (state) => {
        state.isLoading = true
        state.error = null
      })
      .addCase(setPriceAlerts.fulfilled, (state, {payload}) => {
        state.alertsList = payload.alerts
        state.isLoading = false
      })
      .addCase(asyncLogout.fulfilled, (state) => {
        state.alertsList = []
      })
  },
})

export default PriceAlertsSlice.reducer
